<template>
  <container>
    <row wrap class="mb-8">
      <column
        v-for="(item, index) in items"
        :key="index"
        class="w-full md:w-1/2 xl:w-1/3"
      >
        <info-box v-bind="item" />
      </column>
    </row>
  </container>
</template>
<script>
import VueTypes from 'vue-types'
import { InfoBox } from '~/components/molecules'
import { Container, Row, Column } from '~/components/grid'
export default {
  components: {
    Container,
    Row,
    Column,
    InfoBox,
  },
  props: {
    items: VueTypes.array.def([]),
  },
}
</script>
